import React from "react";
import "./../styles/Fields.css";

//SET BACKGROUND WHEN NO DATA IS EXTRACTED
export function checkDataOnLoad() {
  var x = document.getElementsByClassName("textbox");
  for (var i = 0; i < x.length; i++) {
    if (x.item(i).value == "" || x.item(i).value.toLowerCase() == "not found") {
      x.item(i).value = "Not Found";
      x.item(i).style.color = "white";
      x.item(i).style.backgroundColor = "red";
    }
  }
}
function checkOnClick(e) {
  var element = document.getElementById(e.target.id);
  console.log("background color ", element.style.backgroundColor);
  if (element.style.backgroundColor == "yellow") {
    element.style.removeProperty("color");
    element.style.removeProperty("background-color");
  }
}

function DateClickEvent(e) {
  var element = document.getElementById(e.target.id);
  if (element.style.backgroundColor == "yellow") {
    element.style.removeProperty("color");
    element.style.removeProperty("background-color");
  }
  // this.props.callingFunction;
}
//END

export const FieldsClinical = (props) => {
  //DISPLAY OF FIELD BASE ON TYPE
  if (props.type === "line-break") {
    return <div className="break"></div>;
  } else if (props.type === "textarea-small") {
    return (
      <div className="field-container">
        <div className="field-label">
          <label className="">{props.fieldLabel}</label>
        </div>
        <div className="field-text-full">
          {props.taskStatus != 7 &&
          props.taskStatus != 8 &&
          props.taskStatus != 19 ? (
            <textarea
              //id={`${props.txtId}`}
              id={"txt" + `${props.txtId}`}
              name={`${props.txtId}`}
              datalabel={`${props.datalabel}`}
              className={`textarea ${props.textAreaClass} ${props.textStyle} ${props.focusStyle}`}
              onClick={checkOnClick}
              onFocus={props.originalValue}
              defaultValue={props.dataText}
              onMouseDown={props.move_box_click}
              onChange={props.updateStateValue}
              onBlur={props.updateField}
            ></textarea>
          ) : (
            <textarea
              //id={`${props.txtId}`}
              id={"txt" + `${props.txtId}`}
              name={`${props.txtId}`}
              datalabel={`${props.datalabel}`}
              className={`textarea ${props.textAreaClass} ${props.textStyle} ${props.focusStyle}`}
              onClick={checkOnClick}
              defaultValue={props.dataText}
              onMouseDown={props.move_box_click}
              readOnly
            ></textarea>
          )}
          <div className={props.focusStyleDiv}></div>
        </div>
        <div>{props.confidenceIcon}</div>
        <div>{props.missingCoords}</div>
      </div>
    );
  } else if (props.type === "dropdown") {
    if (props.dropdownType === "umReviewtype") {
      return (
        <div className="field-container">
          <div className="field-label">
            <label className="">{props.fieldLabel}</label>
          </div>
          <div className="field-text">
            <select
              id={`${props.txtId}`}
              className="dropdownCB"
              onFocus={props.originalValue}
              onChange={(e) => props.setUMReviewTypeSelected(e.target.value)}
              // onChange={props.updateField}
              // name="UMReviewType_CR"
            >
              {props.umReviewTypeCB.map((item) => (
                <option
                  key={item.Code_CR}
                  value={item.Description_CR}
                  selected={
                    item.Description_CR == props.selectedUMReviewTypeData
                      ? true
                      : false
                  }
                >
                  {item.Description_CR}
                </option>
              ))}
            </select>
          </div>
          <div>{props.confidenceText}</div>
          <div>{props.missingCoords}</div>
        </div>
      );
    } else if (props.dropdownType === "requestProfile") {
      return (
        <div className="field-container">
          <div className="field-label">
            <label className="">{props.fieldLabel}</label>
          </div>
          <div className="field-text">
            <select
              id={`${props.txtId}`}
              className="dropdownCB"
              onFocus={props.originalValue}
              onChange={(e) => props.setSelectedRequestProfile(e.target.value)}
            >
              {<option value=""></option>}
              {props.requestProfileCB.map((item) => (
                <option
                  key={item.Code_CR}
                  value={item.Description_CR}
                  selected={
                    item.Description_CR == props.requestProfileData
                      ? true
                      : false
                  }
                >
                  {item.Description_CR}
                </option>
              ))}
            </select>
          </div>
          <div>{props.confidenceText}</div>
          <div>{props.missingCoords}</div>
        </div>
      );
    } else if (props.dropdownType === "admissionSource") {
      return (
        <div className="field-container">
          <div className="field-label">
            <label className="">{props.fieldLabel}</label>
          </div>
          <div className="field-text">
            <select
              id={`${props.txtId}`}
              className="dropdownCB"
              onFocus={props.originalValue}
              onChange={(e) => props.setAdmissionSourceSelected(e.target.value)}
            >
              {<option value=""></option>}
              {props.admissionSourceCB.map((item) => (
                <option key={item.Code_CR} value={item.Description_CR}>
                  {item.Description_CR}
                </option>
              ))}
            </select>
          </div>
          <div>{props.confidenceText}</div>
          <div>{props.missingCoords}</div>
        </div>
      );
    } else if (props.dropdownType === "admissionType") {
      return (
        <div className="field-container">
          <div className="field-label">
            <label className="">{props.fieldLabel}</label>
          </div>
          <div className="field-text">
            <select
              id={`${props.txtId}`}
              onFocus={props.originalValue}
              className="dropdownCB"
              onChange={(e) => {
                props.setAdmissionTypeSelected(e.target.value);
                // props.updateField;
              }}
            >
              {<option value=""></option>}
              {props.admissionTypeCB.map((item) => (
                <option key={item.Code_CR} value={item.Description_CR}>
                  {item.Description_CR}
                </option>
              ))}
            </select>
          </div>
          <div>{props.confidenceText}</div>
          <div>{props.missingCoords}</div>
        </div>
      );
    }
  } else if (props.type === "ready-only-text") {
    return (
      <div className="field-container">
        <div className="field-label">
          <label className="">{props.fieldLabel}</label>
        </div>
        <div className="field-text">
          <input
            id={"txt" + `${props.txtId}`}
            name={`${props.txtId}`}
            className="textbox-read-only"
            onClick={checkOnClick}
            onFocus={props.move_box_click}
            value={props.dataText}
            readOnly
          ></input>
        </div>
        <div>{props.confidenceText}</div>
        <div>{props.missingCoords}</div>
      </div>
    );
  } else if (props.type === "date") {
    return (
      <div className="field-container">
        <div className="field-label">
          <label className="">{props.fieldLabel}</label>
        </div>
        <div className="field-text">
          {props.taskStatus != 7 &&
          props.taskStatus != 8 &&
          props.taskStatus != 19 ? (
            <input
              id={"txt" + `${props.txtId}`}
              name={`${props.txtId}`}
              datalabel={`${props.datalabel}`}
              className={`textbox ${props.textStyle} ${props.focusStyle}`}
              //onClick={checkOnClick}
              //onClick={DateClickEvent}
              // , props.move_box_click}
              //callingFunction={props.move_box_click}
              onMouseDown={props.move_box_click}
              //onFocus={props.move_box_click}
              defaultValue={props.dataText}
              onChange={props.updateStateValue}
              onBlur={props.updateField}
              type="date"
            ></input>
          ) : (
            <input
              id={"txt" + `${props.txtId}`}
              name={`${props.txtId}`}
              datalabel={`${props.datalabel}`}
              className={`textbox ${props.textStyle} ${props.focusStyle}`}
              onClick={checkOnClick}
              onMouseDown={props.move_box_click}
              //onFocus={props.move_box_click}
              defaultValue={props.dataText}
              type="date"
              readOnly
            ></input>
          )}
        </div>
        <div>{props.confidenceIcon}</div>
        <div>{props.missingCoords}</div>
      </div>
    );
  } else {
    return (
      <div className="field-container">
        <div className="field-label">
          <label className="">{props.fieldLabel}</label>
        </div>
        <div className="field-text">
          {props.taskStatus != 7 &&
          props.taskStatus != 8 &&
          props.taskStatus != 19 ? (
            <input
              id={"txt" + `${props.txtId}`}
              name={`${props.txtId}`}
              datalabel={`${props.datalabel}`}
              className={`textbox ${props.textStyle} ${props.focusStyle}`}
              onClick={checkOnClick}
              onMouseDown={props.move_box_click}
              onFocus={props.originalValue}
              defaultValue={props.dataText}
              onChange={props.updateStateValue}
              onBlur={props.updateField}
            ></input>
          ) : (
            <input
              id={"txt" + `${props.txtId}`}
              name={`${props.txtId}`}
              datalabel={`${props.datalabel}`}
              className={`textbox ${props.textStyle} ${props.focusStyle}`}
              //onClick={checkOnClick}
              onMouseDown={props.move_box_click}
              defaultValue={props.dataText}
              readOnly
            ></input>
          )}
        </div>
        <div>{props.confidenceIcon}</div>
        <div>{props.missingCoords}</div>
      </div>
    );
  }
};
